export enum actions {
  RESET_TO_DEFAULT_DATA = "RESET_TO_DEFAULT_DATA",
  SET_PAGE_INDEX = "SET_PAGE_INDEX",
  INCREMENT_PAGE_INDEX = "INCREMENT_PAGE_INDEX",
  DECREMENT_PAGE_INDEX = "DECREMENT_PAGE_INDEX",
}
